module.exports = __webpack_public_path__ + "static/media/bets.a52ad17c.png";